import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { id: "page" }
const _hoisted_2 = {
  class: "o-container u-pad-y-0 js-main-container u-bg-white",
  style: {"position":"relative"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_gev_header = _resolveComponent("gev-header")!
  const _component_modal = _resolveComponent("modal")!
  const _component_gev_footer = _resolveComponent("gev-footer")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_gev_header),
    _createElementVNode("main", _hoisted_2, [
      _cache[1] || (_cache[1] = _createElementVNode("div", { style: {"height":"70vh"} }, " ", -1)),
      (_ctx.zeigeHinweis)
        ? (_openBlock(), _createBlock(_component_modal, {
            key: 0,
            titel: "Neuer Privathaftpflichttarif",
            onCloseModal: _ctx.weiterZuNeu
          }, {
            inhalt: _withCtx(() => _cache[0] || (_cache[0] = [
              _createTextVNode(" Wir haben einen neuen Tarif. Ihr vorliegender Vorschlag ist leider nicht mehr gültig. Sie können hier ein neues Angebot berechnen. ")
            ])),
            _: 1
          }, 8, ["onCloseModal"]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_gev_footer)
  ]))
}